var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndividual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 13.635C17.7499 13.635 20.8177 10.5671 20.8177 6.8175C20.8177 3.06787 17.7499 0 14.0002 0C10.2506 0 7.18273 3.06787 7.18273 6.8175C7.18273 10.5671 10.2506 13.635 14.0002 13.635ZM14.0002 15.3394C7.0123 15.3394 0.365234 19.7708 0.365234 23.8612C0.365234 27.27 14.0002 27.27 14.0002 27.27C14.0002 27.27 27.6352 27.27 27.6352 23.8612C27.6352 19.7708 20.9882 15.3394 14.0002 15.3394Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividual);
export default __webpack_public_path__ + "static/media/individual.176f63f0005eacd391d3e2ac35a70280.svg";
export { ForwardRef as ReactComponent };